export enum ComponentModificationMode {
    ALWAYS_EDIT = "ALWAYS_EDIT",
    ALWAYS_VIEW = "ALWAYS_VIEW",
    COMPONENT_DECIDES = "COMPONENT_DECIDES"
}
